import store from "../store";
import { commonService } from "./common.service";
import { env } from "../env";

export const posteLivraisonService = {
  getPosteLivraisonsParc,
  postPosteLivraison,
  putPosteLivraison,
  deletePosteLivraison
};

function getPosteLivraisonsParc(parcId) {
  const url = new URL(`${env.apiUrl}/poste-livraisons/parcs/${parcId}`);

  return commonService.getRessource(url);
}

function postPosteLivraison(posteLivraison) {
  const url = new URL(`${env.apiUrl}/poste-livraisons`);

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.getters.token,
    },
    body: JSON.stringify(posteLivraison)
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

function putPosteLivraison(posteLivraison) {
  const url = new URL(`${env.apiUrl}/poste-livraisons`);

  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.getters.token,
    },
    body: JSON.stringify(posteLivraison)
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

function deletePosteLivraison(posteLivraisonId) {
  const url = new URL(`${env.apiUrl}/poste-livraisons/${posteLivraisonId}`);

  const requestOptions = {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + store.getters.token,
    }
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}
